import {
  AliasTypeImplementation,
  CustomTypeImplementation,
  UniqueTypeImplementation,
} from './TypeImplementationDefinition';

export type TypeImplementation =
  | AliasTypeImplementation
  | CustomTypeImplementation<any>
  | UniqueTypeImplementation;

export const Alias = AliasTypeImplementation.create;

export const Custom = CustomTypeImplementation.create;

export const Unique = UniqueTypeImplementation.create;

type TypeImplementationMatcher<a> = {
  Alias: (arg1: AliasTypeImplementation) => a;
  Custom: (arg1: CustomTypeImplementation<unknown>) => a;
  Unique: (arg1: UniqueTypeImplementation) => a;
};

export function match<a>(matchers: TypeImplementationMatcher<a>) {
  return (impl: TypeImplementation) => {
    if (impl instanceof AliasTypeImplementation) return matchers.Alias(impl);
    if (impl instanceof UniqueTypeImplementation) return matchers.Unique(impl);
    return matchers.Custom(impl);
  };
}
